import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {saveInfo} from './reducers/todo-reducer';
import ModalComponent from './ModalCmpt';

const userData = ['nombre', 'apellidos', 'correo', 'telefono'];
const initialState = {
    nombre:null,
    apellidos:null,
    correo:null,
    telefono:null,
    mensaje:{},
    tipoTelefono:"celular",
    mostrar : false,
    loading: false
}
class App extends Component {

  constructor(props){
    super(props);
    this.state = initialState;
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.successSaveInfo){
        this.setState(initialState,()=>{
           this.setState({propsModal:nextProps.successSaveInfo,mostrar:true,muestraSpin:false,loading:false});
        });
    }
  }

  render() {
  

    return (
        <div className="formulario-cotiza">  
        <div className="titulo">
                Auto Elite
        </div>
        <div className="contenidoFormulario">
            <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="col-md-5 col-sm-6 col-xs-6">
                    <div className="form-group">
                        <label htmlFor="nombre">Nombre <span className="requiredIn">*</span></label>
                        <input type="text" maxLength="40" className="form-control" id="nombre" name="nombre"
                          value={this.state.nombre ? this.state.nombre : ""}
                          onChange={this.changeValues.bind(this)}/>
                        {
                            this.state.mensaje ? 
                               this.state.mensaje.nombre ? <p className="errorMsj">{this.state.mensaje.nombre}</p> : null
                            :null
                        }
                        
                    </div>
                </div>
        
                    <div className="col-md-7 col-sm-6 col-xs-6">
                        <div className="form-group">
                            <label htmlFor="apellidos">Apellidos <span className="requiredIn">*</span></label>
                            <input type="text" maxLength="40" className="form-control" name="apellidos" id="apellidos"
                            value={this.state.apellidos ? this.state.apellidos : ""}
                            onChange={this.changeValues.bind(this)}/>
                            {
                            this.state.mensaje ? 
                               this.state.mensaje.apellidos ? <p className="errorMsj">{this.state.mensaje.apellidos}</p> : null
                            :null
                            }
                        </div>
                    </div>
           </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="col-md-10 col-sm-12 col-xs-12">
                    <div className="form-group">
                        <label htmlFor="correo">Correo Electrónico <span className="requiredIn">*</span></label>
                        <input type="text" maxLength="40" className="form-control" name="correo" id="correo" 
                        value={this.state.correo ? this.state.correo : ""}
                        onChange={this.changeValues.bind(this)} />
                        {
                            this.state.mensaje ? 
                               this.state.mensaje.correo ? <p className="errorMsj">{this.state.mensaje.correo}</p> : null
                            :null
                        }
                    </div>
                </div>
            </div>
             <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="col-md-4 col-sm-6 col-xs-6">
                    <div className="form-group desbordeTipoTelefono">
                        <label htmlFor="tipotelefono">Tipo Teléfono <span className="requiredIn">*</span></label>
                        <select className="form-control" id="tipoTelefono" name="tipoTelefono"
                        value={this.state.tipoTelefono}
                        onChange={this.changeValues.bind(this)}>
                            <option value="celular">Celular</option>
                            <option value="local">Local</option>
                        </select>
                    </div>
                </div>
            
      
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <div className="form-group">
                            <label htmlFor="telefono">Teléfono (10 dígitos) <span className="requiredIn">*</span></label>
                            <input type="text" maxLength="10" className="form-control" id="telefono" name="telefono" 
                            value={this.state.telefono ? this.state.telefono : ""}
                            onChange={this.changeValues.bind(this)}/>
                            {
                            this.state.mensaje ? 
                               this.state.mensaje.telefono ? <p className="errorMsj">{this.state.mensaje.telefono}</p> : null
                            :null
                            }
                        </div>
                    </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                        <input type="button" value="Enviar" className="btn btn-gnp"  onClick={this.clicKMuestra.bind(this)}/>
                        {   
                            this.state.muestraSpin ? 
                                    <label className="iconEspera"></label>
                            :null
                        }
                    </div>
        </div>

        <ModalComponent propsModal={this.state.propsModal} mostrar={this.state.mostrar} />

                {
                    this.state.loading ? 
                    <div className="gnp-loading">
                        <div className="circle-orange"></div>
                        <div className="circle-blue"></div>
                        <div className="logo"><img src="https://storage.googleapis.com/static-portalcorporativo.gnp.com.mx/images/site/logo_header @1x.svg" 
                        className="fr-fic fr-dib" /></div>
                    </div>
                    : null
                }

       </div> 
    );
  }

  changeValues(event){

    var name = event.target.name;
    var value = event.target.value;
    var mensaje=this.state.mensaje;
    
    
    mensaje[name]=null;
    this.setState({[name]:value,mensaje,mostrar:false});
  }

    getUserAgent() {
        const ua = navigator.userAgent;
        let dispositvo;
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
            ua
          )
        ) {
          dispositvo = 'Mobile';
        } else if (/Chrome/i.test(ua)) {
          dispositvo = 'Desktop';
        } else {
          dispositvo = 'Desktop';
        }
        return dispositvo;
    }


 clicKMuestra(event){
    this.setState({mostrar:false});
    var mensaje = this.state.mensaje;
    var valido = true;

    for(var i=0; i < userData.length; i++){
        var re;
        var plural=false;
        if(!this.state[userData[i]]){
            mensaje[userData[i]] = "Campo requerido.";
            valido=false;
        }else if(this.state[userData[i]].trim()===""){
            mensaje[userData[i]] = "Campo requerido.";
            valido=false;
        }else{
            console.log("Switch");
            switch (userData[i]) {
                case 'correo':
                  re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  break;
                case 'telefono':
                  re = /^\d{10}$/;
                  break;
                case 'apellidos':
                  re = /^[a-z\u00E0-\u00FC ]+$/i;
                  plural = true;
                  break;
                case 'nombre':
                  re = /^[a-z\u00E0-\u00FC ]+$/i;
                  break;
                default:
                  console.log(userData[i])
              }


              if(!re.test(this.state[userData[i]])){
                if (plural) {
                  mensaje[userData[i]] = "Capture " + userData[i] + " válidos.";
                } else {
                    mensaje[userData[i]]  = "Capture un " + (userData[i].trim() === "telefono" ? "teléfono" : userData[i]) + " válido.";
                }
                valido=false;
              }
        }
    }

   this.setState({mensaje});
  

    if(valido){
        window.dataLayer.push({
            'event': 'virtualEvent',
            'Proceso': 'Registro',
            'TipoEvento': 'Interacción',
            'TipoZona': 'Personas',
            'Zona': 'Autos y Motos',
            'SubZona': 'Seguro de Autos',
            'Pantalla': 'Auto Elite',
            'Sección': 'Cotizar',
            'TipoElemento': 'Button',
            'Intención': 'Registrar solicitud',
            'CTA': 'Enviar',
            'LeadId': '0',
            'PagePath': window.location.pathname,
            'TimeStamp': Date.now(),
            'TipoDispositivo': this.getUserAgent()
        });

        console.log("Se envió."); 

        var values = this.state;
        delete values.loading;
        this.setState({loading:true});

        this.props.actions.saveInfo(values);
    }

 }

 muestraSpin(){
     this.setState({muestraSpin:true});
 }

 
  
}
  
const mapStateToProps = (state) => {
    return {
        successSaveInfo: state.todoReducer.get("successSaveInfo")
    };
  }
  
  
  const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({saveInfo : saveInfo }, dispatch)
    }
  }
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(App);


// WEBPACK FOOTER //
// ./src/App.js